/*
 * SPDX-FileCopyrightText: © 2023 Schneider Electric
 *
 * SPDX-License-Identifier: LGPL-2.1-only
 */
:host {
  --qds-navigation-background: rgb(233 222 245);

  width: 100%;
}

footer {
  display: flex;
  box-sizing: border-box;
  justify-content: center;
  padding: 56px;
  position: relative;
  background-color: var(--qds-theme-navigation-background);
  overflow: hidden;
}

.image {
  position: absolute;
  right: 0;
  bottom: 0;
  opacity: 0.18;
  mix-blend-mode: luminosity;
  width: 549px;
  height: 365px;
  object-position: top;
}

.small-height {
  .image {
    bottom: -50%;
  }
}

.content {
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: var(--qds-navigation-padding);
  width: 100%;
  max-width: 1424px;

  .hidden {
    display: none;
  }
}

.cta {
  display: flex;
  flex-direction: column;
  gap: var(--qds-navigation-padding);
}

::slotted([slot="cta"]) {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(232px, 1fr));
  gap: var(--qds-navigation-section-gap-children-unrelated);
}

.menu {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(232px, 1fr));
  gap: var(--qds-navigation-section-gap-children-unrelated);
}

::slotted(:not([slot])) {
  display: flex;
  flex-direction: column;
  gap: var(--qds-main-subsection-gap-children-related);
  margin: 0;
  padding: 0;
  list-style: none;
}

.methods {
  display: flex;
  flex-wrap: wrap;
  gap: var(--qds-navigation-section-gap-children-unrelated);
}

.media-logo {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  height: 56px;
}

::slotted([slot="media"]) {
  display: flex;
  align-items: center;
  gap: var(--qds-control-small-gap-siblings-related);
  margin: 0;
  padding: 0;
  list-style: none;
}

.bottom-links {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

::slotted([slot="links"]) {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: var(--qds-main-subsection-gap-children-unrelated);
}

.copyright {
  font-family: var(--qds-font-family-brand);
  font-size: var(--qds-control-standard-text);
  color: var(--qds-theme-text-subdued);
  margin: 0;
}

@media (width <= 767px) {
  footer {
    padding: 24px 16px;
    min-width: 320px;
  }

  .image {
    width: 510px;
    height: 210px;
    object-fit: cover;
    object-position: top;
  }

  .small-height {
    .image {
      bottom: 0;
    }
  }

  .methods {
    flex-direction: column;
  }

  .media-logo {
    flex-direction: column;
    gap: 40px;
    align-items: flex-start;
  }

  .bottom-links {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--qds-navigation-section-gap-children-unrelated);
  }

  ::slotted([slot="links"]) {
    flex-direction: column;
    gap: var(--qds-navigation-section-gap-children-related);
  }
}

@media (width > 767px) and (width <= 1024px) {
  footer {
    padding: 24px;
    min-width: 320px;
  }
}
